import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { getI18nText } from 'pricing-pages-lib/utils/languageUtils';
import { useHistory } from 'react-router-dom';
import { trackClickedLink } from '../../utils/tracking/trackingEventUtils';
import { jsx as _jsx } from "react/jsx-runtime";
const RedirectToCustomerPlatformButton = ({
  trackingSource,
  size,
  'data-selenium-id': seleniumId
}) => {
  const history = useHistory();
  const handleClick = () => {
    trackClickedLink({
      type: 'internal',
      url: '/suite',
      trackingSource,
      value: getI18nText('pricingPage.pricingCtas.goToBundlePage', {
        locale: 'en-us'
      })
    });
    history.push('/suite');
  };
  return /*#__PURE__*/_jsx(Button, {
    "data-selenium-id": `${seleniumId}-go-to-suite-page-button`,
    onClick: handleClick,
    block: true,
    size: size,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricingPage.pricingCtas.goToBundlePage"
    })
  });
};
export default RedirectToCustomerPlatformButton;